import * as api from '../api';

const saveNewLogoActions = api.fetchActions('settings', 'save-new-logo');

export const actionTypes = {
  ...saveNewLogoActions.actionTypes,
  ADD_LOGO_DATA: 'settings.add-logo-data',
  ADD_LOGO_CONTENT: 'settings.add-logo-content',
}

export const changeLogo = (name, contentType, size, content, currentLogoUrl) =>
  api.postThunk('/settings/ChangeLogo',
  { fileName: name, fileContentType: contentType, fileSize: size, fileContent: content },
  saveNewLogoActions,
  { currentLogoUrl });

export function doChangeLogo(name, contentType, size, content, currentLogoUrl) {
  return (dispatch) => {
    return dispatch(changeLogo(name, contentType, size, content, currentLogoUrl));
  }
}

export function addLogoData(name, contentType, size) {
  return{
    type: actionTypes.ADD_LOGO_DATA,
    name,
    contentType,
    size
  }
}

export function addLogoContent(content) {
  return{
    type: actionTypes.ADD_LOGO_CONTENT,
    content
  }
}
